import { customElement } from 'aurelia-framework';
import { RangeBaseCustomElement } from 'General/Resources/Elements/Range/RangeBase';

@customElement('range')
export class RangeCustomElement extends RangeBaseCustomElement { }